var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "hero is-fullheight" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-one-third is-offset-one-third" },
            [
              _c("div", { staticClass: "card", attrs: { id: "login-card" } }, [
                _c("div", { staticClass: "card-content" }, [
                  _c("img", {
                    staticClass: "text-center",
                    attrs: {
                      src: require("@/assets/gps_logo.png"),
                      alt: "Gps logo",
                      width: "400px",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "buttons is-flex is-flex-direction-column is-justify-content-center is-align-items-center px-5 py-3",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "is-primary",
                            "icon-pack": "fab",
                            "icon-left": "windows",
                            expanded: "",
                          },
                          on: { click: _vm.onSsoLogin },
                        },
                        [_vm._v(" Continue with Microsoft ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "is-info",
                            "icon-pack": "fas",
                            "icon-left": "mobile-screen-button",
                            disabled: "",
                            expanded: "",
                          },
                        },
                        [_vm._v(" NC application ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            "icon-pack": "fas",
                            "icon-left": "arrow-right-from-bracket",
                            expanded: "",
                          },
                          on: { click: _vm.openGLPI },
                        },
                        [_vm._v(" Report issues ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }